import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as spaceUse from '../../../../space-use'
import * as employee from '../room'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Classification for how the room is used',
    isOptional: true,
    name: 'Space Use',
    // TODO: change to just 'type'
    partialId: PartialId.Standard.create('space_use'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(spaceUse.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
